import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import ProgressRing from '@saucelabs/sl-component-progress-ring';
import { IconCancelOutline } from '@saucelabs/sl-component-icons';
import classNames from 'classnames/bind';

import MobileAppDescription from './MobileAppDescription';
import { APP_UPLOAD_STATUS } from '../constants';
import { AppUploadingRecord } from '../records';
import ThumbnailAndroid from '../images/thumbnail-android.svg';
import ThumbnailIOS from '../images/thumbnail-iOS.svg';
import Styles from './MobileAppUploadingTableRow.styles';

const context = classNames.bind(Styles);

const MobileAppUploadingTableRow = ({ app, uploadAppCancel }) => {
  let Thumbnail;

  if (/\.apk$/.test(app.displayName)) {
    Thumbnail = ThumbnailAndroid;
  } else if (/\.ipa$/.test(app.displayName)) {
    Thumbnail = ThumbnailIOS;
  }

  return (
    <tr
      className={context('row', {
        canceled: app.status === APP_UPLOAD_STATUS.CANCELED,
      })}
    >
      <td colSpan="4">
        <div className={Styles['row-container']}>
          <MobileAppDescription
            displayName={`${app.displayName} (...uploading)`}
            id={app.id}
            thumbnail={<Thumbnail />}
          />
          <div className={Styles['progress-container']}>
            <ProgressRing
              className={Styles['progress-ring']}
              progress={app.progress}
              radius={15}
              stroke={4}
            />
            <IconCancelOutline
              className={Styles['cancel-icon']}
              onClick={() => uploadAppCancel(app.id)}
            />
          </div>
        </div>
      </td>
    </tr>
  );
};

MobileAppUploadingTableRow.propTypes = {
  app: ImmutablePropTypes.recordOf(AppUploadingRecord).isRequired,
  uploadAppCancel: PropTypes.func.isRequired,
};

export default MobileAppUploadingTableRow;
